<ng-container *ngIf="referrerProduct$ | async as referrerProduct">
  <div class="top-content">
    {{ resizingOfExpandedImage() }}
    <h1>{{ businessType == 'fish' ? selectedExplodedViewName : referrerProduct.name }}</h1>
    <div ngbDropdown class="d-inline-block exploded-view-ids" (openChange)="onOpenChangeEvId($event)">
      <button class="btn my-auto" id="explodedViewIds" ngbDropdownToggle>
        <span [class.selected-name]="businessType == 'fish'">
          {{ businessType == 'fish' ? selectedExplodedViewName : activeExplodedViewId }}
        </span>
        <mat-icon class="material-icons-sharp select-button" [class.rotated]="dropdownIsOpened">expand_more</mat-icon>
      </button>
      <ng-container *ngIf="businessType !== 'fish'; else forFish">
        <div ngbDropdownMenu aria-labelledby="explodedViewIds" class="rounded-0 border-0" [ngClass]="businessType">
          <button
            ngbDropdownItem
            *ngFor="let explodedViewId of evUidList | keyvalue : valueAscOrder"
            [routerLink]="
              ['../../', { cxRoute: 'explodedView', params: { explodedViewId: explodedViewId.value } }] | cxUrl
            "
          >
            {{ explodedViewId.value }}
          </button>
        </div>
      </ng-container>
      <ng-template #forFish>
        <div ngbDropdownMenu aria-labelledby="explodedViewIds" class="rounded-0 border-0" [ngClass]="businessType">
          <button
            [class.selected]="explodedViewId.uid === activeExplodedViewId"
            ngbDropdownItem
            (click)="onNameSelection(explodedViewId.displayName)"
            *ngFor="let explodedViewId of referrerProduct.explodedViewList"
            [routerLink]="
              ['../../', { cxRoute: 'explodedView', params: { explodedViewId: explodedViewId.uid } }] | cxUrl
            "
          >
            <span>
              <mat-icon
                svgIcon="check"
                class="selected-icon"
                *ngIf="explodedViewId.uid === activeExplodedViewId"
                [class.selectedEV]="evSelected(explodedViewId)"
              ></mat-icon>
            </span>
            <app-tooltip-text
              class="dropdown-items-tooltip"
              [tooltipContent]="explodedViewId.displayName"
              [content]="explodedViewId.displayName"
              placement="right"
            ></app-tooltip-text>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
  <ng-container *ngIf="explodedView$ | async as explodedView; else evLoading">
    {{ posWhileLoading(explodedView) }}
    <div
      #leftContent
      class="left-content overflow-auto"
      id="products-container"
      [class.d-none]="componentService.expandedImageClicked$ | async"
      [style.height.px]="
        (componentService.initImageContainerHeight$ | async)
          ? (componentService.initImageContainerHeight$ | async)
          : bodyContent?.offsetHeight
      "
    >
      <app-exploded-view-product-listing
        [products$]="products$"
        [productCodesWithBomItemNoMoq]="productCodesWithBomItemNoMoq"
        [dealerPrices]="dealerPrices"
        [basepriceHidden]="basepriceBehavior"
        [explodedViewId]="activeExplodedViewId"
        [boms]="evBoms"
        (messageEvent)="hasProductInEVList($event)"
        [isDiscontinuedEnabled]="isDiscontinuedEnabled"
      ></app-exploded-view-product-listing>
    </div>
    <div
      #bodyContent
      class="body-content"
      [class.w-100]="!isMobile && !isTablet && componentService.expandedImageClicked$ | async"
      [class.h-90]="!isMobile && !isTablet && componentService.expandedImageClicked$ | async"
      [class.tablet-expanded]="isTablet && componentService.expandedImageClicked$ | async"
      [class.mobile-expanded]="isMobile && componentService.expandedImageClicked$ | async"
      [class.px-0]="isMobile"
      [class.container]="isTablet || isMobile"
    >
      <div [class.row]="isTablet">
        <div class="col-md-12 px-0">
          <div
            #imageContainer
            id="image-container"
            class="image-container"
            [class.overflow-auto]="componentService.expandedImageClicked$ | async"
            *ngIf="explodedView?.image?.url && explodedView?.image?.url !== 'null'"
          >
            <img
              #image
              class="desktopImage"
              [src]="explodedView.image.url"
              [class.tablet-expanded]="isTablet && componentService.expandedImageClicked$ | async"
              [class.mobile-expanded]="isMobile && componentService.expandedImageClicked$ | async"
            />
            <ng-container *ngFor="let bomHotspots of uniqueBomHotspots$ | async">
              <ng-container *ngFor="let bomHotspot of bomHotspots">
                <label *ngIf="bomHotspot?.hotspot" [for]="bomHotspot?.hotspot?.uid">
                  <div
                    #hotspot
                    *ngIf="leftContent && bodyContent && bomHotspot && getProductsCountInPopover(bomHotspot.itemNo)"
                    class="hotspot-button"
                    [id]="'hotspot-' + bomHotspot.itemNo"
                    [class.selected]="isActive(bomHotspot.itemNo)"
                    [style.left.px]="
                      getScaledCoordinateX(bomHotspot.hotspot.coordinateX, leftContent, bodyContent, image)
                    "
                    [style.top.px]="
                      getScaledCoordinateY(bomHotspot.hotspot.coordinateY, leftContent, bodyContent, image)
                    "
                    [style.paddingRight.px]="businessType == 'fish' ? 8 : 0"
                    [style.paddingLeft.px]="businessType == 'fish' ? 8 : 0"
                    [style.width]="
                      businessType == 'fish' ? 'auto' : bomHotspot.hotspot.width * scaledFactorStyle + 'px'
                    "
                    [style.min-width.px]="bomHotspot.hotspot.width * scaledFactorStyle"
                    [style.height.px]="bomHotspot.hotspot.height * scaledFactorStyle"
                    [style.line-height.px]="bomHotspot.hotspot.height * scaledFactorStyle"
                    [style.font-size.px]="bomHotspot.hotspot.height * scaledFactorStyle * 0.7"
                    [class.pill]="bomHotspot.itemNo.toString().length > 2"
                    [class.disabled]="isDisabled(bomHotspot.itemNo) | async"
                    [class.mobile-expanded]="isMobile && componentService.expandedImageClicked$ | async"
                    data-toggle="collapse"
                    [attr.data-target]="'#collapse-' + bomHotspot.itemNo"
                    (click)="
                      toggleSelectedProduct(bomHotspot.itemNo, !isActive(bomHotspot.itemNo));
                      showPopover(
                        {
                          event: $event
                        },
                        isActive(bomHotspot.itemNo)
                      )
                    "
                  >
                    <span>{{ bomHotspot.itemNo }}</span>
                  </div>
                </label>
              </ng-container>
            </ng-container>
            <button
              mat-icon-button
              class="toggle-image"
              [class.tablet-expanded]="isTablet && componentService.expandedImageClicked$ | async"
              [class.mobile-expanded]="isMobile && componentService.expandedImageClicked$ | async"
              [disableRipple]="true"
              (click)="toggleExpandImage()"
              [style.right.px]="toggleExpandImagePosition()"
            >
              <mat-icon
                svgIcon="expand-image"
                *ngIf="!(componentService.expandedImageClicked$ | async)"
                [inline]="true"
              ></mat-icon>
              <mat-icon
                svgIcon="shrink-image"
                *ngIf="componentService.expandedImageClicked$ | async"
                [inline]="true"
              ></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #evLoading>
    <div class="loading-container">
      <mat-spinner [diameter]="72"></mat-spinner>
    </div>
  </ng-template>
</ng-container>
